/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){
	function initEventListeners(){
        pipEvents.augmentedReality.augmentedRealityDrawerActivated.off();
        pipEvents.augmentedReality.augmentedRealityDrawerActivated.on(function() {

        var obj = {
          eventInfo: {
            eventName: 'pip sub-content'
          },
          category: {
            primaryCategory: 'interaction'
          },
          subContent: {
            section: 'see it in your space',
            component: 'augmented reality',
            target: 'not applicable'
          },
        };


        if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
    })
	}
	return {
		init: function init(){
			initEventListeners();
		}
	}
});

}.call(window));